// =============================================================================
// OperacaoDetalheSheet - detalhe da operação num MODAL LATERAL (~56% da tela)
// =============================================================================
// Aberto ao clicar num card da esteira (Quadro / sub-board), no lugar de navegar
// para a página /operacoes/:id (que continua existindo para deep-links). Busca o
// detalhe completo (getById) e renderiza o OperacaoModal dentro do painel lateral.
// =============================================================================

import { useEffect, useState } from 'react';
import { Sheet, SheetContent } from './ui/sheet';
import OperacaoModal from './OperacaoModal';
import { operacoesApi } from '../services/api';
import type { Operacao } from '../types';

interface Props {
  operacaoId: string | null;
  onClose: () => void;
  onUpdated?: (op: Operacao) => void;
}

export default function OperacaoDetalheSheet({ operacaoId, onClose, onUpdated }: Props) {
  const [op, setOp] = useState<Operacao | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!operacaoId) { setOp(null); setErro(null); return; }
    let ativo = true;
    setCarregando(true);
    setErro(null);
    setOp(null);
    operacoesApi.getById(operacaoId)
      .then((d) => { if (ativo) setOp(d); })
      .catch(() => { if (ativo) setErro('Operação não encontrada.'); })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [operacaoId]);

  return (
    <Sheet open={!!operacaoId} onOpenChange={(aberto) => { if (!aberto) onClose(); }}>
      <SheetContent
        side="right"
        className="w-full sm:w-[56%] sm:max-w-none p-0 gap-0 flex flex-col bg-[#F0F2F5]"
      >
        {carregando && (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-400">
            Carregando operação…
          </div>
        )}
        {erro && (
          <div className="m-4 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-2 rounded-lg">
            {erro}
          </div>
        )}
        {op && (
          <OperacaoModal
            operacao={op}
            onClose={onClose}
            onUpdate={(nova) => { setOp(nova); onUpdated?.(nova); }}
          />
        )}
      </SheetContent>
    </Sheet>
  );
}
